import { Col, Container, Row } from "react-bootstrap"
import SessionStore from "../lazyLoaders/session_lazy"

export const NoneFound = ({ item_name, min_height }) => {
    const chapterNumber = SessionStore.getChapterKey('phone_number')
    const chapterName = SessionStore.getChapterKey('name')
    return (
        <Container
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: min_height ? min_height : 0 }}>
            <Row className="w-100">
                <Col xs={12} sm={10} md={6} lg={4} className="mx-auto">
                    {chapterName ? (
                        <p>No {item_name ? item_name : 'items'} found. Please reach out to the {chapterName}{chapterNumber && ` at ${chapterNumber}`}</p>
                    ) : (
                        <p> No {item_name ? item_name : 'items'} found.</p>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
